module.exports = __webpack_public_path__ + "media/chat_1.13458d15.mp3";